import React, { useState } from 'react';
import i18next from 'core/i18n';
import { DialogContent, DialogActions, Button, DialogProps } from '@indigo-ag/component-module';

import { createStylesHook } from 'shared/hooks/createStylesHook';
import { EnhancedDialog } from '../EnhancedDialog/EnhancedDialog';
import { text } from 'shared/utils';

interface ConfirmationDialogProps extends DialogProps {
  closeDialog: () => void;
  onConfirmPromise: () => Promise<any>;
  confirmationText: string;
  confirmationButtonText?: string;
  destructive?: boolean;
  dialogMaxHeight?: string;
  dialogMaxWidth?: string;
}

const useStyles = createStylesHook({
  MuiDialogActionsRoot: {
    margin: 0,
    padding: 32
  }
});

export const ConfirmationDialog: React.FunctionComponent<ConfirmationDialogProps> = ({
  open,
  closeDialog,
  onConfirmPromise,
  confirmationText,
  confirmationButtonText,
  destructive,
  dialogMaxHeight = '280px',
  dialogMaxWidth = '22rem'
}) => {
  /**
   * State
   */
  const [busy, setBusy] = useState(false);

  /**
   * Styles
   */
  const classes = useStyles();

  const handleConfirmAction = () => {
    setBusy(true);
    onConfirmPromise()
      .then(() => {
        closeDialog();
      })
      .finally(() => setBusy(false));
  };
  return (
    <EnhancedDialog
      open={open}
      onClose={closeDialog}
      title={i18next.t('confirmation')}
      dialogMinHeight="0"
      dialogMaxHeight={dialogMaxHeight}
      dialogMaxWidth={dialogMaxWidth}
    >
      <DialogContent>
        <div style={{ textAlign: 'center', paddingBottom: 40 }}>{i18next.t(confirmationText)}</div>
      </DialogContent>
      <DialogActions classes={{ root: classes.MuiDialogActionsRoot }}>
        <Button onClick={closeDialog} type="button" size="small" variant="secondary">
          {i18next.t('cancel')}
        </Button>
        <Button onClick={handleConfirmAction} type="submit" size="small" busy={busy} destructive={!!destructive}>
          {confirmationButtonText
            ? text.firstLetterUppercase(i18next.t(confirmationButtonText))
            : text.firstLetterUppercase(i18next.t('continue'))}
        </Button>
      </DialogActions>
    </EnhancedDialog>
  );
};
